import React from 'react'
import styled from 'styled-components'
import { PATHPREFIX } from '../../../../constants'

const Arrow = () => (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.244127 8.57738C-0.081305 8.90287 -0.081305 9.43045 0.244127 9.75594C0.569558 10.0814 1.09719 10.0814 1.42261 9.75594L0.244127 8.57738ZM9.16655 0.833527L9.99987 0.833535C9.99987 0.373309 9.62679 0.000218831 9.16655 0.000207331V0.833527ZM0.833341 2.62006e-10C0.37311 -1.14162e-05 1.14167e-05 0.373069 2.62006e-10 0.833302C-1.14162e-05 1.29353 0.373069 1.66663 0.833299 1.66664L0.833341 2.62006e-10ZM8.33315 9.16645C8.33315 9.62669 8.70622 9.99977 9.16647 9.99977C9.62671 9.99977 9.99978 9.62669 9.99978 9.16645H8.33315ZM1.42261 9.75594L9.75579 1.42278L8.57723 0.244281L0.244127 8.57738L1.42261 9.75594ZM0.833299 1.66664L9.16647 1.66685L9.16655 0.000207331L0.833341 2.62006e-10L0.833299 1.66664ZM8.33323 0.833518L8.33315 9.16645H9.99978L9.99987 0.833535L8.33323 0.833518Z"
      fill="#fff"
    />
  </svg>
)

const PrismaDayLogo = () => (
  <svg width="101" height="54" viewBox="0 0 101 54" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.22466 2.64866C11.1122 2.64866 12.7461 2.96326 14.1262 3.59244C15.5266 4.22163 16.6024 5.11466 17.3533 6.27155C18.1043 7.42844 18.4798 8.79843 18.4798 10.3815C18.4798 11.9444 18.1043 13.3144 17.3533 14.4915C16.6024 15.6484 15.5266 16.5415 14.1262 17.1706C12.7461 17.7795 11.1122 18.084 9.22466 18.084H4.93199V23.9598H0V2.64866H9.22466ZM8.95066 14.0653C10.4323 14.0653 11.5587 13.7507 12.33 13.1215C13.1012 12.4721 13.4869 11.5587 13.4869 10.3815C13.4869 9.18406 13.1012 8.27073 12.33 7.64155C11.5587 6.99207 10.4323 6.66733 8.95066 6.66733H4.93199V14.0653H8.95066Z"
      fill="white"
    />
    <path
      d="M24.9844 9.74221C25.5527 8.95066 26.3138 8.35192 27.2677 7.94599C28.2419 7.54007 29.3582 7.3371 30.6166 7.3371V11.7211C30.0889 11.6805 29.7337 11.6602 29.5511 11.6602C28.1912 11.6602 27.1256 12.0458 26.3544 12.8171C25.5831 13.5681 25.1975 14.7046 25.1975 16.2269V23.9598H20.4482V7.58066H24.9844V9.74221Z"
      fill="white"
    />
    <path
      d="M32.2228 7.58066H36.9721V23.9598H32.2228V7.58066ZM34.5974 5.29733C33.7247 5.29733 33.0143 5.04362 32.4663 4.53622C31.9183 4.02881 31.6443 3.39963 31.6443 2.64866C31.6443 1.8977 31.9183 1.26852 32.4663 0.761111C33.0143 0.253704 33.7247 0 34.5974 0C35.4702 0 36.1806 0.243556 36.7286 0.730667C37.2766 1.21778 37.5506 1.82667 37.5506 2.55733C37.5506 3.34889 37.2766 4.00851 36.7286 4.53622C36.1806 5.04362 35.4702 5.29733 34.5974 5.29733Z"
      fill="white"
    />
    <path
      d="M45.6726 24.2033C44.3127 24.2033 42.9833 24.0409 41.6843 23.7162C40.3854 23.3712 39.3503 22.9449 38.579 22.4375L40.1621 19.0278C40.8928 19.4946 41.7757 19.8802 42.8108 20.1846C43.8459 20.4688 44.8607 20.6109 45.8552 20.6109C47.8646 20.6109 48.8692 20.1136 48.8692 19.1191C48.8692 18.6523 48.5952 18.3174 48.0472 18.1144C47.4992 17.9115 46.6569 17.7389 45.5203 17.5969C44.1808 17.3939 43.0746 17.1605 42.2019 16.8966C41.3292 16.6328 40.568 16.166 39.9186 15.4962C39.2894 14.8264 38.9748 13.8725 38.9748 12.6344C38.9748 11.5993 39.2691 10.686 39.8577 9.89443C40.4666 9.08258 41.3393 8.4534 42.4759 8.00688C43.6328 7.56036 44.9926 7.3371 46.5554 7.3371C47.7123 7.3371 48.8591 7.46903 49.9957 7.73288C51.1525 7.97643 52.1065 8.32147 52.8574 8.76799L51.2743 12.1473C49.8333 11.3355 48.2603 10.9295 46.5554 10.9295C45.5406 10.9295 44.7795 11.0716 44.2721 11.3558C43.7647 11.6399 43.511 12.0052 43.511 12.4518C43.511 12.9592 43.785 13.3144 44.333 13.5173C44.881 13.7203 45.7537 13.9131 46.9512 14.0958C48.2908 14.319 49.3868 14.5626 50.2392 14.8264C51.0917 15.07 51.8325 15.5266 52.4617 16.1964C53.0908 16.8662 53.4054 17.7998 53.4054 18.9973C53.4054 20.0121 53.101 20.9153 52.4921 21.7069C51.8832 22.4984 50.9902 23.1175 49.813 23.564C48.6561 23.9902 47.276 24.2033 45.6726 24.2033Z"
      fill="white"
    />
    <path
      d="M76.0941 7.3371C78.1441 7.3371 79.7678 7.94599 80.9652 9.16377C82.183 10.3612 82.7919 12.1676 82.7919 14.5829V23.9598H78.0426V15.3135C78.0426 14.0146 77.7686 13.0505 77.2206 12.4213C76.6929 11.7718 75.9318 11.4471 74.9372 11.4471C73.8209 11.4471 72.9381 11.8124 72.2886 12.5431C71.6391 13.2535 71.3144 14.319 71.3144 15.7398V23.9598H66.565V15.3135C66.565 12.7359 65.5299 11.4471 63.4597 11.4471C62.3637 11.4471 61.491 11.8124 60.8415 12.5431C60.192 13.2535 59.8673 14.319 59.8673 15.7398V23.9598H55.1179V7.58066H59.6541V9.46821C60.263 8.77814 61.0039 8.25043 61.8766 7.8851C62.7696 7.51977 63.7438 7.3371 64.7993 7.3371C65.9561 7.3371 67.0014 7.57051 67.935 8.03733C68.8687 8.48384 69.6196 9.14347 70.1879 10.0162C70.8577 9.16377 71.7 8.50414 72.7148 8.03733C73.7499 7.57051 74.8764 7.3371 76.0941 7.3371Z"
      fill="white"
    />
    <path
      d="M92.4375 7.3371C94.9746 7.3371 96.923 7.94599 98.2829 9.16377C99.6427 10.3612 100.323 12.1778 100.323 14.6133V23.9598H95.8778V21.92C94.9847 23.4422 93.3204 24.2033 90.8849 24.2033C89.6265 24.2033 88.5305 23.9902 87.5969 23.564C86.6836 23.1378 85.9833 22.5492 85.4962 21.7982C85.0091 21.0472 84.7656 20.1948 84.7656 19.2409C84.7656 17.7186 85.3339 16.5212 86.4704 15.6484C87.6273 14.7757 89.4033 14.3393 91.7982 14.3393H95.5733C95.5733 13.3042 95.2587 12.5127 94.6295 11.9647C94.0004 11.3964 93.0566 11.1122 91.7982 11.1122C90.9255 11.1122 90.0629 11.2543 89.2104 11.5384C88.3783 11.8023 87.6679 12.1676 87.0793 12.6344L85.3744 9.31599C86.2675 8.6868 87.333 8.19969 88.5711 7.85466C89.8295 7.50962 91.1183 7.3371 92.4375 7.3371ZM92.0722 21.0066C92.8841 21.0066 93.6046 20.824 94.2338 20.4586C94.863 20.073 95.3095 19.5149 95.5733 18.7842V17.1098H92.3158C90.3673 17.1098 89.3931 17.7491 89.3931 19.0278C89.3931 19.6366 89.6265 20.1238 90.0933 20.4891C90.5804 20.8341 91.2401 21.0066 92.0722 21.0066Z"
      fill="white"
    />
    <path
      d="M0 26.4968H9.68132C11.9951 26.4968 14.0349 26.9433 15.8006 27.8363C17.5867 28.7091 18.9669 29.9471 19.9411 31.5506C20.9356 33.154 21.4329 35.0212 21.4329 37.1523C21.4329 39.2834 20.9356 41.1507 19.9411 42.7541C18.9669 44.3575 17.5867 45.6057 15.8006 46.4988C14.0349 47.3715 11.9951 47.8079 9.68132 47.8079H0V26.4968ZM9.43777 43.7588C11.5689 43.7588 13.2636 43.1702 14.522 41.993C15.8006 40.7955 16.44 39.182 16.44 37.1523C16.44 35.1227 15.8006 33.5193 14.522 32.3421C13.2636 31.1446 11.5689 30.5459 9.43777 30.5459H4.93199V43.7588H9.43777Z"
      fill="white"
    />
    <path
      d="M30.2061 31.1852C32.7431 31.1852 34.6916 31.7941 36.0514 33.0119C37.4113 34.2094 38.0912 36.0259 38.0912 38.4614V47.8079H33.6463V45.7681C32.7533 47.2903 31.089 48.0514 28.6534 48.0514C27.395 48.0514 26.2991 47.8383 25.3654 47.4121C24.4521 46.9859 23.7519 46.3973 23.2648 45.6463C22.7776 44.8954 22.5341 44.0429 22.5341 43.089C22.5341 41.5668 23.1024 40.3693 24.239 39.4965C25.3959 38.6238 27.1718 38.1874 29.5668 38.1874H33.3419C33.3419 37.1523 33.0273 36.3608 32.3981 35.8128C31.7689 35.2445 30.8251 34.9603 29.5668 34.9603C28.694 34.9603 27.8314 35.1024 26.979 35.3865C26.1468 35.6504 25.4365 36.0157 24.8479 36.4825L23.143 33.1641C24.036 32.5349 25.1016 32.0478 26.3396 31.7028C27.598 31.3577 28.8868 31.1852 30.2061 31.1852ZM29.8407 44.8548C30.6526 44.8548 31.3731 44.6721 32.0023 44.3068C32.6315 43.9211 33.078 43.363 33.3419 42.6323V40.9579H30.0843C28.1359 40.9579 27.1616 41.5972 27.1616 42.8759C27.1616 43.4848 27.3951 43.9719 27.8619 44.3372C28.349 44.6822 29.0086 44.8548 29.8407 44.8548Z"
      fill="white"
    />
    <path
      d="M57.1318 31.4288L49.7338 48.8125C48.9828 50.7001 48.0492 52.0295 46.9329 52.8008C45.8369 53.572 44.5075 53.9576 42.9447 53.9576C42.0922 53.9576 41.2499 53.8257 40.4178 53.5619C39.5857 53.298 38.9057 52.9327 38.378 52.4659L40.1134 49.0865C40.4787 49.4113 40.8948 49.665 41.3616 49.8476C41.8487 50.0303 42.3256 50.1216 42.7925 50.1216C43.4419 50.1216 43.9696 49.9593 44.3756 49.6345C44.7815 49.3301 45.1468 48.8125 45.4716 48.0819L45.5325 47.9296L38.4389 31.4288H43.3405L47.9376 42.541L52.5651 31.4288H57.1318Z"
      fill="white"
    />
  </svg>
)

export default () => (
  <Container>
    <Main>
      <Logo>
        <PrismaDayLogo />
      </Logo>
      <Text>Prisma Day will be livestreamed on June 25th & 26th</Text>
      <Button target="_blank" href="https://www.prisma.io/day">
        Join us
        <Arrow />
      </Button>
    </Main>
  </Container>
)

const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  background-color: #082133;
  background-repeat: no-repeat;
  background-position: left center;
  background-image: none;
  background-size: contain;
  border-radius: 8px;

  @media screen and (min-width: 420px) {
    background-image: url('${PATHPREFIX}/blog/posts/prisma-day-globe.png');
  }
`

const Main = styled.div`
  padding: 16px 24px;
  flex: 1;
  flex-wrap: wrap;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;

  @media screen and (min-width: 420px) {
    padding: 16px 24px 16px 96px;
  }
`

const Logo = styled.div`
  svg {
    display: block;
    height: 40px;
    width: auto;
  }

  @media screen and (min-width: 420px) {
    svg {
      height: 54px;
    }
  }
`

const Text = styled.div`
  display: none;
  color: #8da4b4;

  @media screen and (min-width: 700px) {
    display: block;
  }
`

const Button = styled.a`
  white-space: nowrap;
  background-color: #9f6bf4;
  border-radius: 6px;
  height: 36px;
  color: white;
  display: flex;
  align-items: center;
  padding: 0 12px;
  font-weight: 600;

  svg {
    opacity: 0.5;
    margin-left: 8px;
  }
`
